import { useWebsiteSettings } from 'client/store'
import { BorderStyleEnum, BorderType } from 'common/types/styleTypes'
import { buttonAndFormFieldSelectorMap } from 'src/editor/store/website-settings/website-settings-selector'
import {
  WebsiteButtonAndFormFieldTypes,
  WebsiteSettingsTypographyTypeEnum,
} from 'src/shared/types/website-settings-types'
import { useThemeColor } from './use-theme-color'

export const useCalculateBorder = ({
  border,
  mobileBorder,
  type,
}: {
  border?: Partial<BorderType>
  mobileBorder?: Partial<BorderType>
  type: WebsiteButtonAndFormFieldTypes
}) => {
  const { border: globalBorder } =
    useWebsiteSettings(buttonAndFormFieldSelectorMap[type]) || {}
  const { buttons, formFields } = useThemeColor()

  let globalBorderColor = ''
  if (type === WebsiteSettingsTypographyTypeEnum.PrimaryButton) {
    globalBorderColor = buttons?.primaryButtonBorderColor || ''
  } else if (type === WebsiteSettingsTypographyTypeEnum.SecondaryButton) {
    globalBorderColor = buttons?.secondaryButtonBorderColor || ''
  } else if (type === WebsiteSettingsTypographyTypeEnum.FormField) {
    globalBorderColor = formFields?.formFieldBorderColor || ''
  }

  return {
    calculatedBorder: {
      mobile: {
        color: mobileBorder?.color ?? globalBorderColor,
        radius:
          typeof mobileBorder?.radius === 'object' &&
          typeof globalBorder?.radius === 'object'
            ? {
                borderTopLeftRadius:
                  mobileBorder?.radius?.borderTopLeftRadius ??
                  globalBorder?.radius?.borderTopLeftRadius,
                borderTopRightRadius:
                  mobileBorder?.radius?.borderTopRightRadius ??
                  globalBorder?.radius?.borderTopRightRadius,
                borderBottomRightRadius:
                  mobileBorder?.radius?.borderBottomRightRadius ??
                  globalBorder?.radius?.borderBottomRightRadius,
                borderBottomLeftRadius:
                  mobileBorder?.radius?.borderBottomLeftRadius ??
                  globalBorder?.radius?.borderBottomLeftRadius,
              }
            : (mobileBorder?.radius ?? globalBorder?.radius),
        type: mobileBorder?.type ?? globalBorder?.type,
        style:
          (mobileBorder?.style as BorderStyleEnum) ??
          (globalBorder?.style as BorderStyleEnum),
        width: mobileBorder?.width ?? globalBorder?.width,
      },
      desktop: {
        color: border?.color ?? globalBorderColor,
        radius:
          typeof border?.radius === 'object' &&
          typeof globalBorder?.radius === 'object'
            ? {
                borderTopLeftRadius:
                  border?.radius?.borderTopLeftRadius ??
                  globalBorder?.radius?.borderTopLeftRadius,
                borderTopRightRadius:
                  border?.radius?.borderTopRightRadius ??
                  globalBorder?.radius?.borderTopRightRadius,
                borderBottomRightRadius:
                  border?.radius?.borderBottomRightRadius ??
                  globalBorder?.radius?.borderBottomRightRadius,
                borderBottomLeftRadius:
                  border?.radius?.borderBottomLeftRadius ??
                  globalBorder?.radius?.borderBottomLeftRadius,
              }
            : (border?.radius ?? globalBorder?.radius),
        type: border?.type ?? globalBorder?.type,
        style:
          (border?.style as BorderStyleEnum) ??
          (globalBorder?.style as BorderStyleEnum),
        width: border?.width ?? globalBorder?.width,
      },
    },
  }
}
